import {Observer, PageContainer} from "web-vcore";
import React from "react";
import {Button, Column, Row, Text} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {ScrollView} from "react-vscrollview";
import {GetScenes} from "../../Server/DB/scenes.js";
import {MeID} from "../../Server/DB/users.js";
import {ES} from "web-vcore";
import {ShowSignInPopup} from "../@Shared/NavBar/UserPanel";
import {TagTargetEntryUI} from "../@Shared/TagTargetEntryUI.js";
import {ShowAddSceneDialog} from "./Scenes/SceneDetailsUI.js";
import {observer_mgl} from "mobx-graphlink";

export const columnWidths = [.25, .1, .1, .3, .25];

export const ScenesUI = observer_mgl(()=>{
	const scenes = GetScenes().filter(a=>a && a.creator == MeID()); // defensive (temp)
	const userID = MeID();

	return (
		<PageContainer style={{margin: "20px auto 20px auto", padding: 0}}>
			<Column className="clickThrough" style={{height: 80, borderRadius: "10px 10px 0 0"}}>
				<Row center style={{height: 40, padding: 10}}>
					<Button text="Add scene" ml="auto" onClick={()=>{
						if (MeID() == null) return ShowSignInPopup();
						ShowAddSceneDialog();
					}} />
				</Row>
				<Row style={{height: 40, padding: 10}}>
					<Text style={{flex: columnWidths[0], fontWeight: 500, fontSize: 16}}>Name</Text>
					<Text style={{flex: columnWidths[1], fontWeight: 500, fontSize: 16}}>Preview</Text>
					<Text style={{flex: columnWidths[2], fontWeight: 500, fontSize: 16}}>Creator</Text>
					<Text style={{flex: columnWidths[3], fontWeight: 500, fontSize: 16}}><Text>Tags (click tags to </Text><span style={{color: "rgba(100,200,100,.7)"}}>accept</span>)</Text>
					<Text style={{flex: columnWidths[4], fontWeight: 500, fontSize: 16}}></Text>
				</Row>
			</Column>
			<ScrollView style={ES({flex: 1})} contentStyle={ES({flex: 1})}>
				{scenes.length == 0 && <div style={{textAlign: "center", fontSize: 18}}>No entries.</div>}
				{scenes.map((scene, index)=>{
					return <TagTargetEntryUI key={index} index={index} last={index == scenes.length - 1} group="scenes" entry={scene} />;
				})}
			</ScrollView>
		</PageContainer>
	);
});